import { Flex } from '@common/components/Flex';
import * as React from 'react';
import { DatasheetComponentTextStyle } from '@common/dto/datasheet/component-settings/text-style';
import { DatasheetFieldComponentTextAlign } from '@common/dto/datasheet/field-component/text-align';

import './datasheet-item-label.styles.scss';

export type DatasheetItemLabelProps = {
  text: string;
  img: string;
  withImg?: boolean;
  withText?: boolean;
  textCustomization?: {
    fontStyles?: Array<DatasheetComponentTextStyle>;
    fontSize?: number;
    fontFamily?: string;
    color?: number;
    align?: DatasheetFieldComponentTextAlign;
  };
  inline?: boolean;
  reference?: React.RefObject<HTMLDivElement>;
};

export const DatasheetItemLabel: React.FC<DatasheetItemLabelProps> = (props) => {
  const { img, text, withImg, withText, textCustomization, inline, reference } = props;

  const justifyMap: Record<DatasheetFieldComponentTextAlign, React.CSSProperties['justifyContent']> = {
    [DatasheetFieldComponentTextAlign.center]: 'center',
    [DatasheetFieldComponentTextAlign.left]: 'flex-start',
    [DatasheetFieldComponentTextAlign.right]: 'flex-end',
  };

  return (
    <Flex 
      inline={inline}
      reference={reference}
      className="DatasheetsDatasheetItemLabel" 
      alignItems="center" 
      justify={textCustomization?.align ? justifyMap[textCustomization.align] : 'flex-start'}
    >
      {withImg && <img className="DatasheetsDatasheetItemLabel__img" src={img} alt={text} />}
      {withText && (
        <span 
          style={{
            fontSize: textCustomization?.fontSize,
            fontFamily: textCustomization?.fontFamily,
            color: textCustomization?.color ? `#${textCustomization.color.toString(16)}` : undefined,
            fontStyle: textCustomization?.fontStyles?.includes(DatasheetComponentTextStyle.italic) ? 'italic' : undefined,
            fontWeight: textCustomization?.fontStyles?.includes(DatasheetComponentTextStyle.bold) ? 'bold' : undefined,
            textDecoration: textCustomization?.fontStyles?.includes(DatasheetComponentTextStyle.underline) ? 'underline' : 'none',
          }}
          className="DatasheetsDatasheetItemLabel__text"
        >
          {text}
        </span>
      )}
    </Flex>
  );
};